import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LcsApiService } from '@lcs/shared/api';
import { Observable } from 'rxjs';
import { AccountFinalization } from '../models/account-finalization.model';
import { AccountVerification } from '../models/account-verification.model';

@Injectable({ providedIn: 'root' })
export class AccountVerificationApiService {
   constructor(private http: HttpClient, private apiService: LcsApiService) {}

   activateAccount(token: string): Observable<AccountVerification> {
      const requestUrl = this.apiService.buildApiUrl('Signup/AccountVerification?token=' + encodeURIComponent(token));
      const headers = new HttpHeaders().set('Allow-Control-Allow-Origin', '*');
      return this.http.get<AccountVerification>(requestUrl, { headers });
   }

   canAccountBeFinalized(token: string): Observable<boolean> {
      const requestUrl = this.apiService.buildApiUrl('Users/CanAccountBeFinalized') + '?token=' + encodeURIComponent(token);
      return this.http.get<boolean>(requestUrl);
   }

   savePassword(accountFinalization: AccountFinalization, token: string): Observable<void> {
      const requestUrl = this.apiService.buildApiUrl('Users/AccountFinalization') + '?token=' + encodeURIComponent(token);
      return this.http.post<void>(requestUrl, accountFinalization);
   }
}
